import * as $ from "jquery";
import * as _ from "lodash";
import * as Backbone from "backbone";
import {PermissionCollection} from "../../../collections/Permissions";
import {TemplateConversionFunctionCollection} from "../../../collections/TemplateConversionFunctions";
import {TemplateChannelParamCollection} from "../../../collections/TemplateChannelParams";
import {ConversionFunctionCollection} from "../../../collections/ConversionFunctions";
import {ChannelParamCollection} from "../../../collections/ChannelParams";
import {SensorRecord} from "../../../models/Module";

var template = require('templates/settings/sensor_config/modbusoperation.html');
var positionFieldsTemplate = require('templates/settings/sensor_config/modbuspositionfields.html');
positionFieldsTemplate = _.template(positionFieldsTemplate);

interface ModbusOperationViewOptions extends Backbone.ViewOptions<Backbone.Model> {
    permissionCollection: PermissionCollection;
    templateConversionFunctions: TemplateConversionFunctionCollection;
    templateChannelParams: TemplateChannelParamCollection;
    conversionFunctionCollection: ConversionFunctionCollection;
    channelParamCollection: ChannelParamCollection;
    installId: number;
    opNumber: number;
    connector: number;
    con: SensorRecord;
    operations: any;
    initial: any;
}


export class ModbusOperationView extends Backbone.View<Backbone.Model> {

    permissionCollection: PermissionCollection;
    templateConversionFunctions: TemplateConversionFunctionCollection;
    templateChannelParams: TemplateChannelParamCollection;
    conversionFunctionCollection: ConversionFunctionCollection;
    channelParamCollection: ChannelParamCollection;
    installId: number;
    opNumber: number;
    connector: number;
    con: SensorRecord;
    operations: any;
    initial: any;

    maxOpId: number;
    removed: boolean;

    constructor(options: ModbusOperationViewOptions) {
        super(options)
    };

    template = _.template(template);

    initialize(options: ModbusOperationViewOptions) {
        this.permissionCollection = options.permissionCollection;
        this.templateConversionFunctions = options.templateConversionFunctions;
        this.templateChannelParams = options.templateChannelParams;
        this.conversionFunctionCollection = options.conversionFunctionCollection;
        this.channelParamCollection = options.channelParamCollection;
        this.installId = options.installId;
        this.opNumber = options.opNumber;
        this.connector = options.connector;
        this.con = options.con;
        this.operations = options.operations;
        this.initial = options.initial;

        this.maxOpId = this.operations.registers.length;
        this.removed = false;

        this.events = <any> {
            'click .settings-sensorconfig-modbusmaster-remove': 'removeModelView',
            'click .settings-sensorconfig-modbusmaster-register-type-single': 'switchSingle',
            'click .settings-sensorconfig-modbusmaster-register-type-multi': 'switchRange',
            'click .settings-sensorconfig-modbusmaster-register-bit-32': 'switch32Bit',
            'click .settings-sensorconfig-modbusmaster-register-bit-16': 'switch16Bit',
            'input .modbus-register-selector': 'updateRegisterInputs',
            'input .modbus-register-range-selector-1': 'updateRegisterInputs',
            'blur .modbus-device-selector': 'handleDeviceAddressChange',
            'blur .modbus-register-range-selector-1': 'handleRegisterRangeBlur',
            'blur .modbus-register-range-selector-2': 'handleRegisterRangeBlur',
            'blur .modbus-register-selector': 'handleRegisterRangeBlur',
            'click .modbus-add-register': 'addModbusBlock',
            'click .modbus-trash-selector': 'removeModbusBlock'
        }
    }

    validate() {
        var errors = [];
        this.$(':input[required]:visible').each((i, input) => {
            if(!$(input).val()){
                errors.push($(input).attr('placeholder') + " must not be empty")
            }
        });

        var addr = Number(this.$('.modbus-device-selector').val());
        if(addr <= 0 || addr > 254){
            errors.push('Device addresses must be between 1 and 254')
        }

        _.each(this.$('.modbus-block'), (block) => {
            var isRange = $(block).find('.settings-sensorconfig-modbusmaster-register-type-multi').is(':checked');
            var is32bit = $(block).find('.settings-sensorconfig-modbusmaster-register-bit-32').is(':checked');

            var reg1 = Number($(block).find('.modbus-register-range-selector-1').val());
            var reg2 = Number($(block).find('.modbus-register-range-selector-2').val());

            if(reg2 <= reg1 && isRange){
                errors.push('Range end must be greater than range start')
            }
            if(reg1 < 0 || reg1 > 16383 || reg2 < 0 || reg2 > 16383){
                errors.push('Register addresses must be between 0 and 9999')
            }

            if(isRange && is32bit && ((reg2-reg1)%2 !== 0)){
                errors.push('32bit Range (' + reg1 + '-' + reg2 + ') is invalid. The number of registers is odd.')
            }
        });


        var errorContainer = this.$('.modbus-alerts');
        errorContainer.empty();
        if(errors.length){
            errorContainer.removeClass('hidden');
            var eList = $('<ul>').addClass('list-group').addClass('alert-danger');
            _.each(errors, (err) => {
                eList.append($('<li>').addClass('list-group-item').addClass('list-group-item-danger').text(err))
            });
            errorContainer.append(eList);
        }else{
            errorContainer.addClass('hidden');
        }

        return errors;
    };

    removeModelView() {
        this.remove();
        this.removed = true;
    }

    getNewPositionFieldsBlock(channel, address, register, channelParams, conversionFunctions) {
        var canEdit = this.permissionCollection.canModifySensorConfig(this.installId);
        return positionFieldsTemplate({
            address: address,
            channel: channel,
            register: register,
            channelParams: channelParams,
            conversionFunctions: conversionFunctions,
            canEdit: canEdit
        })
    };

    getNewInitialPositionFieldsBlock(channel, address, register) {
        var channelParams = [];
        var conversionFunctions = [];

        if(channel){
            channelParams= this.channelParamCollection.filter(function(p){
                return p.get('channel_id') === channel['channel_id']
            });
            conversionFunctions = this.conversionFunctionCollection.filter(function(f){
                return f.get('channel_id') === channel['channel_id']
            });
        }
        return this.getNewPositionFieldsBlock(channel, address, register, channelParams, conversionFunctions);
    };

    switchSingle(e: JQuery.UIEventBase) {
        var opId = $(e.currentTarget).parents('.modbus-block').attr('data-opid');

        this.$('.modbus-block[data-opid="' + opId + '"] .modbusmaster-register-single').addClass('in');
        this.$('.modbus-block[data-opid="' + opId + '"] .modbusmaster-register-range').removeClass('in');
        this.adjustRegisterPositions(opId);
    };

    switchRange(e: JQuery.UIEventBase) {
        var opId = $(e.currentTarget).parents('.modbus-block').attr('data-opid');

        this.$('.modbus-block[data-opid="' + opId + '"] .modbusmaster-register-single').removeClass('in');
        this.$('.modbus-block[data-opid="' + opId + '"] .modbusmaster-register-range').addClass('in');
        this.adjustRegisterPositions(opId);
    };

    switch32Bit(e: JQuery.UIEventBase) {
        var opId = $(e.currentTarget).parents('.modbus-block').attr('data-opid');
        this.adjustRegisterPositions(opId);
    }

    switch16Bit(e: JQuery.UIEventBase) {
        var opId = $(e.currentTarget).parents('.modbus-block').attr('data-opid');
        this.adjustRegisterPositions(opId);
    }

    updateRegisterInputs(e: JQuery.UIEventBase) {
        var current = $(e.currentTarget);
        var val = current.val();
        var opId = current.parents('.modbus-block').attr('data-opid');

        this.$('.modbus-block[data-opid="' + opId + '"] .modbus-register-selector').val(val);
        this.$('.modbus-block[data-opid="' + opId + '"] .modbus-register-range-selector-1').val(val);
    };

    getBlockNumPositions(opId) {
        var block = this.$('.modbus-block[data-opid="' + opId + '"]');
        var isRange = $(block).find('.settings-sensorconfig-modbusmaster-register-type-multi').is(':checked');
        if(!isRange) return 1;

        var is32bit = $(block).find('.settings-sensorconfig-modbusmaster-register-bit-32').is(':checked');
        var reg1 = Number($(block).find('.modbus-register-range-selector-1').val());
        var reg2 = Number($(block).find('.modbus-register-range-selector-2').val());

        if(reg1 ===0 || reg1 > reg2) return 0;

        if(is32bit){
            return (reg2 - reg1 + 2) / 2
        } else {
            return reg2 - reg1 + 1
        }
    };

    getNewFakeChannel(addr, register, is32bit) {
        addr = addr ? 'Addr ' + addr : 'Invalid Address';
        return {
            channel_name: addr + '-Reg ' + register,
            channel_unit: '',
            channel_position: null,
            channel_id: null,
            channel_allow_select_decimals: true,
            channel_decimals: null
        }
    };

    adjustRegisterPositions(opId) {
        var block = this.$('.modbus-block[data-opid="' + opId + '"]');
        var currentPositions = block.find('.modbus-register-position');
        var currentNumPositions = currentPositions.length;
        var newNumPositions = this.getBlockNumPositions(opId);

        var addr = Number(this.$('.modbus-device-selector').val());
        var positionAddr = Number(currentPositions.eq(0).attr('data-device-address'));
        var positionsContainer = block.find('.modbus-register-positions');
        var reg1 = Number($(block).find('.modbus-register-range-selector-1').val());
        var is32bit = $(block).find('.settings-sensorconfig-modbusmaster-register-bit-32').is(':checked');

        // if the address has changed, we need to replace all positions
        if(positionAddr != addr){
            positionsContainer.empty();
            for(var j=0; j< newNumPositions; j++){
                var register = reg1 + (j * (is32bit ? 2 : 1));
                var channel = this.getNewFakeChannel(addr, register, is32bit);
                positionsContainer.append(this.getNewPositionFieldsBlock(
                    channel, addr, register, this.templateChannelParams.models, this.templateConversionFunctions.models
                ));
            }
        } else {
            var desiredRegisters = [];
            for(var j=0; j< newNumPositions; j++) desiredRegisters.push(reg1 + (j * (is32bit ? 2 : 1)));
            var desiredRegisterIndex = 0;

            // Loop through current positions, removing positions that are no longer needed, and inserting
            // desired positions
            for(var i=0; i<currentPositions.length; i++){

                // Check if we have taken care of all desired registers. If we did, all existing registers can
                // be removed
                if(desiredRegisterIndex == desiredRegisters.length){
                    currentPositions.eq(i).remove();
                    continue;
                }
                var desiredRegister = desiredRegisters[desiredRegisterIndex];

                var currentPosition = currentPositions.eq(i);
                var posRegister = Number(currentPosition.attr('data-register'));
                if(posRegister > desiredRegister){
                    // Insert the desired register
                    var channel = this.getNewFakeChannel(addr, desiredRegister, is32bit);
                    $(<string> this.getNewPositionFieldsBlock(
                        channel, addr, desiredRegister, this.templateChannelParams.models,
                        this.templateConversionFunctions.models
                    )).insertBefore(currentPosition);

                    // Repeat the check against this current position with the next desired register
                    desiredRegisterIndex++;
                    i--;
                } else if(desiredRegister > posRegister){
                    // Repeat the check against the next position with the currently desired register
                    currentPosition.remove();
                } else {
                    // The register is desired and exists currently. Move both indexes forward
                    desiredRegisterIndex++;
                }
            }

            // Insert desired registers that are past the last current position
            for(var k=desiredRegisterIndex; k<desiredRegisters.length; k++){
                var channel = this.getNewFakeChannel(addr, desiredRegisters[k], is32bit);
                positionsContainer.append(this.getNewPositionFieldsBlock(
                    channel, addr, desiredRegisters[k], this.templateChannelParams.models, this.templateConversionFunctions.models
                ));
            }

        }
    }

    handleDeviceAddressChange() {
        var blocks = this.$('.modbus-block');
        for(var i=0; i<blocks.length; i++) this.adjustRegisterPositions(blocks.eq(i).attr('data-opid'));
    };

    handleRegisterRangeBlur(e: JQuery.UIEventBase) {
        var opId = $(e.currentTarget).parents('.modbus-block').attr('data-opid');
        this.adjustRegisterPositions(opId);
    };

    addModbusBlock() {
        this.maxOpId++;
        var newOpId = this.opNumber + '-' + this.maxOpId;

        var clone = this.$('.modbus-block').first().clone();
        clone.attr('data-opid', newOpId);

        clone.removeClass('modbus-initial-block-selector').find('input').val('');
        clone.find('.settings-sensorconfig-modbusmaster-register-type')
            .attr('name', 'modbusmaster-register-type-' + newOpId)
            .val(newOpId);
        clone.find('.settings-sensorconfig-modbusmaster-register-bit')
            .attr('name', 'modbusmaster-register-bit-' + newOpId)
            .val(newOpId);

        clone.find('.settings-sensorconfig-modbusmaster-register-type-multi').prop('checked', false);
        clone.find('.settings-sensorconfig-modbusmaster-register-type-single').prop('checked', true);
        clone.find('.settings-sensorconfig-modbusmaster-register-bit-32').prop('checked', false);
        clone.find('.settings-sensorconfig-modbusmaster-register-bit-16').prop('checked', true);

        clone.find('.modbusmaster-register-single').addClass('in');
        clone.find('.modbusmaster-register-range').removeClass('in');

        clone.find('.modbus-trash-selector').removeClass('hidden');

        clone.find('.modbus-register-positions').empty();

        this.$('.modbus-initial-block-selector-end').before(clone);
        this.delegateEvents();

        clone.find('.modbus-register-selector').focus();
    };

    removeModbusBlock(e: JQuery.UIEventBase) {
        $(e.currentTarget).parents('.modbus-block').remove();
    };

    render(errors?) {
        errors = errors ? errors : [];

        this.$el.html(this.template({
            permissionCollection: this.permissionCollection,
            conversionFunctionCollection: this.conversionFunctionCollection,
            channelParamCollection: this.channelParamCollection,
            installId: this.installId,
            opNumber: this.opNumber,
            operations: this.operations,
            connector: this.connector,
            con: this.con,
            errors: errors
        }));
        _.each(this.operations.registers, (op:any, i) => {
            var opId = this.opNumber + '-' + i;
            var positionsContainer = this.$('.modbus-block[data-opid="' + opId + '"] .modbus-register-positions');

            for(var j=0; j<op.numPositions; j++){
                var register = op.register[0] + (j * (op.bits === 16 ? 1 : 2));

                // Check if this Operation was added when the page was rendered or if it was added by the user
                var block, channel;
                if(this.initial){
                    channel = _.find(this.con['channels'], {channel_position: op.position + j});
                    if(!channel) channel = this.getNewFakeChannel(this.operations.device, register, op.bits === 32);
                    block = this.getNewInitialPositionFieldsBlock(channel, this.operations.device, register);
                } else {
                    channel = this.getNewFakeChannel(op.device, register, false);
                    block = this.getNewPositionFieldsBlock(
                        channel, this.operations.device, register, this.templateChannelParams.models,
                        this.templateConversionFunctions.models
                    );
                }
                positionsContainer.append(block);
            }
        });

        this.delegateEvents();
        return this;
    };

    getConfigAndChannelInfo() {
        var ops = [];
        var device = Number(this.$('.modbus-device-selector').val());
        var func = Number(this.$('.settings-sensorconfig-modbusmaster-modbusfunction').val());

        _.each(this.$('.modbus-block'), (block) => {
            var isRange = $(block).find('.settings-sensorconfig-modbusmaster-register-type-multi').is(':checked');
            var is32bit = $(block).find('.settings-sensorconfig-modbusmaster-register-bit-32').is(':checked');
            var registers = [
                Number($(block).find('.modbus-register-range-selector-1').val())
            ];
            if(isRange){
                registers.push(Number($(block).find('.modbus-register-range-selector-2').val()))
            }
            var channels = [];
            _.each($(block).find('.modbus-register-position'), (position) => {
                var name = $(position).find('.settings-sensorconfig-modbus-channel-name').val();
                var unit = $(position).find('.settings-sensorconfig-modbus-channel-unit').val();
                var conversionFunctionName = $(position).find('.settings-sensorconfig-channel-modbus-conversion-function').val();
                if(conversionFunctionName == -1) conversionFunctionName = null;
                var decimals = Number($(position).find('.settings-sensorconfig-modbus-channel-decimal-digits').val());
                if(decimals === -1) decimals = null;
                var params = [];
                var uiParams = $(position).find('.settings-sensorconfig-modbus-channel-param');
                for(var i=0; i<uiParams.length; i++){
                    var p = uiParams.eq(i);
                    var val = p.val();
                    if(val === ''){
                        val = null;
                    } else {
                        val = Number(val);
                    }
                    params.push({
                        key: p.attr('data-param-key'),
                        value: val
                    })
                }
                channels.push({
                    name: name,
                    unit: unit,
                    decimals: decimals,
                    conversion_function_name: conversionFunctionName,
                    params: params
                })
            });
            ops.push({
                device: device,
                isRange: isRange,
                is32bit: is32bit,
                func: func,
                registers: registers,
                channels: channels
            })
        });
        return ops;
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/settings/sensor_config/ModbusOperation.ts